import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollReset = (scrollRef) => {
  const location = useLocation();

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scroll(0, 0);
    }
  }, [location.pathname, scrollRef]);

  return null;
};

export default useScrollReset;
